import script from "./CrudTpus.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudTpus.vue?vue&type=script&setup=true&lang=js"

import "./CrudTpus.vue?vue&type=style&index=0&id=1e6d35ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6d35ae"]])

export default __exports__